<template>
    <div class="container links" v-if="activeTree">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ name: 'Organisation' }"
                >Dashboard</el-breadcrumb-item
            >
            <el-breadcrumb-item>Links</el-breadcrumb-item>
        </el-breadcrumb>

        <h1 class="container__title h1">
            Links

            <Button :showIcon="false" @click="changes(true)" size="small"
                >Apply Changes
            </Button>

            <Button
                :showIcon="false"
                @click="changes(false)"
                type="red"
                size="small"
                >Discard Changes
            </Button>
        </h1>

        <div class="container__section container__section--space-small">
            <h3 class="container__section__title h3">
                General links
                <span class="switch"
                    ><span v-if="generallinks_all === false">Active</span
                    ><span v-if="generallinks_all === true">All</span>
                    <el-switch v-model="generallinks_all"
                /></span>
                <br />
                <span class="switch"
                    ><span v-if="reverse_links === false">Regular Order</span
                    ><span v-if="reverse_links === true">Reverse Order</span>
                    <el-switch v-model="reverse_links"
                /></span>
                <br />
            </h3>

            <template v-if="generalLinks && generalLinks.length > 0">
                <draggable
                    v-model="generalLinks"
                    @end="updateOrder($event, generalLinks, generallinks_all)"
                >
                    <LinkItem
                        class="links__item"
                        v-for="link in generalLinks"
                        :key="link.slug"
                        :link="link"
                        :showinactive="generallinks_all"
                        @edit="open_dialog"
                        @updateLink="updateSingleLink"
                    >
                    </LinkItem>
                </draggable>
            </template>
            <div v-else class="grey container__section__nolinks">
                No links found.
            </div>
        </div>

        <div class="container__section">
            <div class="el-form-item__add">
                <Button
                    :showIcon="true"
                    @click="open_dialog('link', true, false)"
                    >Add link <IconPlus slot="icon"
                /></Button>
            </div>
        </div>

        <div class="container__section container__section--space-small">
            <h3 class="container__section__title h3">
                Social links
                <span class="switch"
                    ><span v-if="sociallinks_all === false">Active</span
                    ><span v-if="sociallinks_all === true">All</span>
                    <el-switch v-model="sociallinks_all"
                /></span>
            </h3>

            <template v-if="socialLinks && socialLinks.length > 0">
                <draggable
                    v-model="socialLinks"
                    @end="updateOrder($event, socialLinks, sociallinks_all)"
                >
                    <LinkItem
                        class="links__item"
                        v-for="link in socialLinks"
                        :key="link.slug"
                        :link="link"
                        :showinactive="sociallinks_all"
                        @edit="open_dialog"
                        @updateLink="updateSingleLink"
                    >
                    </LinkItem>
                </draggable>
            </template>
            <div v-else class="grey container__section__nolinks">
                No social links found
            </div>
        </div>

        <div class="container__section">
            <div class="el-form-item__add">
                <span @click="open_dialog('social_dialog', true, false)">
                    <Button :showIcon="true"
                        >Add social link <IconPlus slot="icon"
                    /></Button>
                </span>
            </div>
        </div>

        <div class="container__section container__section--space-small">
            <h3 class="container__section__title h3">
                Footer links
                <span class="switch"
                    ><span v-if="footerlinks_all === false">Active</span
                    ><span v-if="footerlinks_all === true">All</span>
                    <el-switch v-model="footerlinks_all"
                /></span>
            </h3>

            <template v-if="footerLinks && footerLinks.length > 0">
                <draggable
                    v-model="footerLinks"
                    @end="updateOrder($event, footerLinks, footerlinks_all)"
                >
                    <LinkItem
                        class="links__item"
                        v-for="link in footerLinks"
                        :key="link.slug"
                        :link="link"
                        :showinactive="footerlinks_all"
                        @edit="open_dialog"
                        @updateLink="updateSingleLink"
                    >
                    </LinkItem>
                </draggable>
            </template>
            <div v-else class="grey container__section__nolinks">
                No footer links found
            </div>
        </div>

        <div class="container__section">
            <div class="el-form-item__add">
                <span @click="open_dialog('footer', true, false)">
                    <Button :showIcon="true"
                        >Add footer link <IconPlus slot="icon"
                    /></Button>
                </span>
            </div>
        </div>

        <el-dialog
            :visible.sync="link_dialog"
            :before-close="clear_tree"
            :destroy-on-close="true"
            :close-on-click-modal="false"
        >
            <LinkForm
                :newLink="new_link"
                :config="dialog_type"
                :slug="link_slug"
                @close="clear_tree"
            />
        </el-dialog>
        <el-dialog
            :visible.sync="dialogOrder"
            @closed="triggerReverseOrder"
            :destroy-on-close="true"
        >
            <h2 class="container__title h2">Reverse Order</h2>
            <p style="margin-top:-40px;margin-bottom:30px;">
                Changing the order will have an immediate impact. Do you want to
                continue?
            </p>
            <Button size="big" @click="reverseOrder(true)">Yes</Button>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import linkDialogMixin from '@/mixins/linkDialogMixin.js';
import linkSortingMixin from '@/mixins/linkSortingMixin.js';
import * as api from '@/api';
import LinkItem from '@/components/LinkItem.vue';
import Button from '@/components/Button.vue';
import IconPlus from '@/components/icons/IconPlus.vue';
import LinkForm from '@/components/LinkForm.vue';
import draggable from 'vuedraggable';

export default {
    mixins: [linkDialogMixin, linkSortingMixin],
    components: {
        LinkItem,
        Button,
        IconPlus,
        draggable,
        LinkForm,
    },
    data() {
        return {
            orderChanged: false,
            // generalLinks: false,
            // socialLinks: false,
            // footerLinks: false,
            generallinks_all: true,
            sociallinks_all: true,
            footerlinks_all: true,
            reverse_links: false,
            dialogOrder: false,
            preventOrder: false,
        };
    },
    watch: {
        activeTree() {
            const that = this;
            this.prepareLinkData();

            this.preventOrder = true;
            this.reverse_links = this.activeTree.reverse_link_order === 1;
            setTimeout(function() {
                that.preventOrder = false;
            });
        },
        reverse_links() {
            if (this.preventOrder === false) {
                this.dialogOrder = true;
            }
        },
    },
    computed: {
        ...mapGetters(['activeTree']),
    },
    mounted() {
        this.prepareLinkData();
    },
    methods: {
        triggerReverseOrder() {
            const that = this;
            if (this.preventOrder === false) {
                this.reverseOrder(false);
            }
            setTimeout(function() {
                that.preventOrder = false;
            });
        },
        reverseOrder(doit) {
            this.preventOrder = true;

            if (doit === false) {
                this.reverse_links = !this.reverse_links;
            } else {
                this.saveOrder();
            }

            this.dialogOrder = false;
        },
        async saveOrder() {
            await api.linktree.update(this.$route.params.treeslug, {
                reverse_link_order: this.reverse_links,
            });
            this.$store.commit(
                'setActiveTreeOrder',
                this.reverse_links ? 1 : 0,
            );
        },
        updateOrder(e, links, all) {
            let ni = Number(e.newIndex);
            let elem = false;

            if (!all) {
                let count = 0;
                let found = false;
                let fi = 0;

                if (ni === 0) {
                    fi = 0;
                } else {
                    links.forEach((l, index) => {
                        if (l.active && !found) count++;
                        if (count >= ni && !found) {
                            found = true;
                            fi = index + 1;
                        }
                    });
                }

                elem = links.find(l => {
                    return l.slug === e.clone.dataset.slug;
                });

                elem.position = fi;
            } else {
                elem = links.find(l => {
                    return l.slug === e.clone.dataset.slug;
                });

                elem.position = ni;
            }

            this.updateLink(elem);
            this.orderChanged = true;
        },
        async updateLink(link) {
            try {
                var send_data = new FormData();
                send_data.append('position', link.position);

                var response = await api.link.update(link.slug, send_data);
                this.$store.commit('setActiveTreeLinks', response.data.data);
            } catch (error) {
                console.error(error);
            }
        },
        async changes(apply) {
            try {
                var todo = 'discardChanges';
                var type = 'error';
                var message = 'All changes were removed!';

                if (apply) {
                    todo = 'applyChanges';
                    type = 'success';
                    message = 'All changes applied!';
                }

                var response = await api.linktree[todo](this.activeTree.slug);
                this.$store.commit('setActiveTree', response.data.data);

                this.$message({
                    message: message,
                    type: type,
                });
            } catch (error) {
                console.error(error);
            }
        },
        updateSingleLink(data) {
            var helpdata = JSON.parse(JSON.stringify(this.activeTree));
            helpdata.links.data.forEach((val, key) => {
                if (
                    Object.prototype.hasOwnProperty.call(
                        val.updated_values,
                        'slug',
                    )
                ) {
                    if (val.updated_values.slug == data.slug)
                        helpdata.links.data[key] = data;
                } else {
                    if (val.slug == data.slug) helpdata.links.data[key] = data;
                }
            });

            this.$store.commit('setActiveTree', helpdata);
        },
    },
};
</script>
